import { newAxios } from './index'
import {Cookie} from '@/util'

export const Req_Login = function (data) {
  return newAxios({
    url: `/login`,
    data:{...data,type: 20}
  })()
}

export const Req_GetUserInfo = function () {
  const userId = Cookie.get('jti')
  return newAxios({
    url: `/i/tenant/user/info/${userId}`,
  })()
}

export const Req_UpdatePwd = function (data,isSecond) {
  return newAxios({
    url: isSecond ? '/i/tenant/user/secondary/password/save' : `/i/tenant/user/modify/password`,
    data
  })()
}

export const Req_UpdateUserInfo = function (data) {
  return newAxios({
    url: `/i/tenant/user/update`,
    data
  },'json')()
}

export const Req_UpdateCompanyInfo = function (data) {
  return newAxios({
    url: `/i/tenant/user/group/update`,
    data
  },'json')()
}

export const Req_GetCompanyDetail = function () {
  return newAxios({
    url: `/i/tenant/user/group/info`,
  })()
}

export const Req_GetUserHandleRecord = function (data) {
  return newAxios({
    url: `/i/tenant/system/oper/log/list`,
    data
  })()
}

export const Req_GetUserMsgList = function (data) {
  return newAxios({
    url:`/i/tenant/user/msg/read/list`,
    data
  })()
}

export const Req_GetMsgReadInfo = function (data) {
  return newAxios({
    url: `/i/tenant/user/msg/read/get/type`,
    data
  })()
}

export const Req_ReadMsg = function (data) {
  return newAxios({
    url:`/i/tenant/user/msg/read/read`,
    data
  },'json')()
}

export const Req_GetUnreadCount = function (data) {
  return newAxios({
    url: `/i/tenant/user/msg/read/unread/count`,
    data
  })()
}

//发送重置密码验证码
export const Req_GetResetCode = function (data) {
  return newAxios({
    url: `/user/send/code/password/reset`,
    data
  })()
}

//重置密码 
export const Req_ResetPassword = function (data) {
  return newAxios({
    url: `/user/password/reset`,
    data
  })()
}

//获取权限信息
export const Req_RestGetPermissionConfig = function (data) {
  return newAxios({
    url:`/i/tenant/user/permission/config`,
    data
  })()
}

//通用列表设置保存
export const Req_HeaderConfigSave = function (data) {
  return newAxios({
    url:`/i/tenant/finance/list/header/config/save`,
    data
  },'json')()
}

export const Req_DelHeaderConfig = data => {
  return newAxios({
    url: `/i/tenant/finance/list/header/config/delete`,
    data
  })()
}

//获取通用表设置
export const Req_GetHeaderConfig = function (data) {
  return newAxios({
    url:`/i/tenant/finance/list/header/config/list`,
    data
  })()
}


export const Req_GetMissionMsg = () => {
  return newAxios({
    url: `/i/tenant/user/msg/read/get/type`,
    data: { msgType: 40}
  })()
}


// WEBPACK FOOTER //
// ./src/request/user.js